<template>
  <v-app id="desempenho-por-acs" class="app-tabela">
    <div class="box" style="margin-top: 0px">
      <v-card class="tabela">
        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Busca por UBS, INE da equipe ou microárea"
            class="input-bottom"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :search="search"
          @pagination="getPagination"
          :disable-pagination="true"
          hide-default-footer
          :loading="loading"
          loading-text="Carregando, Por favor espere"
          :headers="headers"
          :items="indexedItems"
          item-key="index"
          class="elevation-1"
          show-expand
          :single-expand="true"
          :expanded.sync="expanded"
        >
          <!-- <template #footer.prepend>
          <v-spacer />
        </template> -->

          <template v-slot:header.resultado="{ header }">
            {{ header.text }}
            <span
              v-b-tooltip.hover.right
              title="Percentual de pessoas visitadas no período analisado."
              class="icon-tooltip"
            >
              <i class="icofont-info-circle"></i>
            </span>
          </template>

          <template v-slot:[`footer.page-text`]="items">
            <span class="paginacao"
              >{{ items.pageStart }} - {{ items.pageStop }} de
              {{ items.itemsLength }} profissionais</span
            >
          </template>

          <template v-slot:item.ordem="{ index }">
            {{ index + 1 + 'º' }}
          </template>

          <template v-slot:item.profissionais="{ item }">
            <div v-if="item.profissionais.length == 1">
              {{ item.profissionais[0] }}
            </div>
            <div v-else class="select-profissional">
              <vue-select
                :options="getOptions(item)"
                label="label"
                :reduce="(opt) => opt.value"
                :placeholder="''"
                v-model="selectedProfissionais[rowKey(item)]"
                @input="(val) => onSelectProfissional(item, val)"
              >
                <div slot="no-options">Não há opções correspondentes</div>
              </vue-select>
            </div>
          </template>

          <template v-slot:item.resultado="{ item }">
            {{ item.resultado != null ? item.resultado + '%' : '' }}
          </template>

          <template v-slot:expanded-item="{ headers, item }">
            <td colspan="9">
              <table class="table table-interna">
                <thead>
                  <tr>
                    <th>
                      Visitados
                      <span
                        v-b-tooltip.hover
                        title="Quantidade de pessoas visitadas no período analisado. Conta somente a última visita por pessoa."
                        class="icon-tooltip"
                      >
                        <i class="icofont-info-circle"></i>
                      </span>
                    </th>
                    <th>
                      Cadastros
                      <span
                        v-b-tooltip.hover
                        title="Quantidade de Cadastros individuais ativos na microárea no período analisado."
                        class="icon-tooltip"
                      >
                        <i class="icofont-info-circle"></i>
                      </span>
                    </th>
                    <th>
                      Desatualizados
                      <span
                        v-b-tooltip.hover
                        title="Cadastros individuais com mais de 2 anos de atualização, são considerados inválidos. É necessário atualizá-los novamente, caso as pessoas ainda residam no território."
                        class="icon-tooltip"
                      >
                        <i class="icofont-info-circle"></i>
                      </span>
                    </th>
                    <th>
                      <span
                        v-b-tooltip.hover
                        title="Percentual de pessoas visitadas no período analisado."
                        class="icon-tooltip"
                      >
                        <i class="icofont-info-circle"></i>
                      </span>
                      Resultado
                    </th>
                    <th>Período</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ item.visitadas }}</td>
                    <td>
                      <div v-if="situacao.value == 'geral'">
                        <button
                          class="btn"
                          @click="modalCadastrosValidos(item)"
                        >
                          {{ item.cadastradas }}
                        </button>
                      </div>
                      <div v-else>
                        {{ item.cadastradas }}
                      </div>
                    </td>
                    <td>
                      {{
                        situacao.value == 'geral' ? item.cadastros_antigos : '-'
                      }}
                    </td>
                    <td>{{ item.resultado }}%</td>
                    <td>
                      {{ formatDate(dataInicial) }} a
                      {{ formatDate(dataFinal) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </template>

          <template v-slot:progress>
            <v-progress-linear
              color="blue"
              :height="10"
              indeterminate
            ></v-progress-linear>
          </template>
          <template v-slot:no-data>
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
          <template v-slot:no-results style="padding: 0px">
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
        </v-data-table>
      </v-card>
    </div>

    <b-modal
      id="modal-desempenho-microarea"
      ref="modal"
      title="Cadastros individuais"
      v-model="modal.show"
      centered
      scrollable
      hide-footer
      size="xl"
    >
      <template #modal-title> Cadastros individuais</template>
      <div class="modal-desempenho-microarea-body">
        <div
          v-if="modal.loading"
          class="d-flex justify-content-center align-items-center"
          style="height: 300px"
        >
          <b-spinner label="Carregando..." variant="primary"></b-spinner>
        </div>
        <div v-else>
          <div class="subtitle">
            <div class="subtitle-item">
              <input
                type="checkbox"
                name=""
                v-model="modal.filter.greens"
                @change="onChangeGreens($event)"
              /><span class="green"></span> Atualizados
            </div>
            <div class="subtitle-item">
              <input
                type="checkbox"
                name=""
                v-model="modal.filter.reds"
                @change="onChangeReds($event)"
              /><span class="red"></span> Desatualizados
            </div>
            <div class="subtitle-item">
              <input
                type="checkbox"
                name=""
                v-model="modal.filter.oranges"
                @change="onChangeOranges($event)"
              /><span class="orange"></span> Mudou-se
            </div>
          </div>
          <table class="table table-interna">
            <thead>
              <tr>
                <!-- <th>Ordem</th> -->
                <th>CPF</th>
                <th>CNS</th>
                <th>Nascimento</th>
                <th>Data</th>
                <th>Mudança</th>
                <th>Cadastrado por</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in modalItems"
                :key="index"
                :class="getRowColorModal(item)"
              >
                <!-- <td>{{ index + 1 }}</td> -->
                <td>
                  {{
                    item.nu_cpf_cidadao != null && item.nu_cpf_cidadao != '0'
                      ? item.nu_cpf_cidadao
                      : ''
                  }}
                </td>
                <td>
                  {{
                    item.nu_cns != null && item.nu_cns != '0' ? item.nu_cns : ''
                  }}
                </td>
                <td>{{ formatDate(item.dt_nascimento) ?? '' }}</td>
                <td>{{ formatDate(item.dt_cadastro) ?? '' }}</td>
                <td>{{ item.ds_dim_tipo_saida_cadastro }}</td>
                <td>{{ item.no_prof }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </b-modal>
  </v-app>
</template>

<script>
import utils from '@/mixins/utils.js'

export default {
  name: 'TabelaCadastros',
  props: {
    cadastros: {
      type: Array,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
    dataInicial: {
      type: String,
      default: '',
    },
    dataFinal: {
      type: String,
      default: '',
    },
    situacao: {
      type: Object,
      default: null,
    },
  },
  mixins: [utils],
  data() {
    return {
      currentPage: 1,
      expanded: [],
      enabled: null,
      search: '',
      headers: [
        {
          text: 'Ordem',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'ordem',
        },
        {
          text: 'UBS',
          align: 'start',
          filterable: true,
          value: 'no_unidade_saude',
        },
        {
          text: 'INE',
          align: 'start',
          filterable: true,
          value: 'nu_ine',
        },
        {
          text: 'Microárea',
          align: 'start',
          filterable: true,
          value: 'nu_micro_area',
        },
        {
          text: 'ACS / TACS',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'profissionais',
        },
        {
          text: 'Resultado',
          align: 'start',
          filterable: false,
          value: 'resultado',
        },
        { text: '', value: 'data-table-expand' },
      ],
      selectedProfissionais: {},
      expanded: [],
      modal: {
        show: false,
        loading: false,
        table: {
          itemsOriginais: [],
          items: [],
        },
        filter: {
          reds: false,
          greens: false,
          oranges: false,
        },
      },
    }
  },
  computed: {
    indexedItems() {
      const sel = this.selectedProfissionais
      return this.cadastros.map((item, index) => {
        const key = this.rowKey(item)
        return {
          index,
          ...item,
          profissionalSelected:
            sel[key] != null ? sel[key] : item.profissionalSelected || null,
        }
      })
    },
    modalItems() {
      let data = this.modal.table.itemsOriginais
      if (this.modal.filter.reds) {
        data = this.modal.table.itemsOriginais.filter((el) => {
          return el.st_cad_valido == 2
        })
      }

      if (this.modal.filter.greens) {
        data = this.modal.table.itemsOriginais.filter((el) => {
          return el.st_cad_valido == 1
        })
      }

      if (this.modal.filter.oranges) {
        data = this.modal.table.itemsOriginais.filter((el) => {
          return el.st_cad_valido == 0
        })
      }

      return data
    },
  },
  watch: {
    cadastros: {
      handler(newValue, oldValue) {
        this.currentPage = 1
      },
      deep: true,
    },
    search: {
      handler(newValue) {
        if (newValue) {
          this.$emit('filterSearch', { filter: this.filterItems(newValue) })
          return
        }
        this.$emit('filterSearch', { filter: false })
      },
      deep: true,
    },
  },
  methods: {
    /**
     * Filtra os registros da tabela com base no texto de busca.
     * Considera apenas as colunas marcadas como filtráveis nos headers.
     * @param {String} search Texto digitado para pesquisa
     * @returns {Array} Lista de itens filtrados
     */
    filterItems(search) {
      const searchTerms = search.toLowerCase().trim()
      const filteredItems = this.cadastros.filter((item) => {
        for (const header of this.headers) {
          if (header.filterable && item.hasOwnProperty(header.value)) {
            const itemValue = String(item[header.value]).toLowerCase()
            if (itemValue.includes(searchTerms)) {
              return true
            }
          }
        }
        return false
      })
      return filteredItems
    },

    /**
     * Atualiza a página atual da tabela.
     * @param {Object} options Dados da paginação
     */
    getPagination(options) {
      this.currentPage = options.page
    },

    rowKey(item) {
      return `${item.nu_ine}-${item.nu_micro_area}`
    },

    getOptions(item) {
      const opts = this.normalizeOptions(item.profissionais)
      const key = this.rowKey(item)

      // Se só existe 1 profissional e ainda não há seleção, seleciona automaticamente
      if (
        opts.length === 1 &&
        (this.selectedProfissionais[key] === undefined ||
          this.selectedProfissionais[key] === null ||
          this.selectedProfissionais[key] === '')
      ) {
        this.$set(this.selectedProfissionais, key, opts[0].value)
      }

      // Se havia um valor selecionado que não existe mais nas opções, limpa
      if (
        opts.length > 0 &&
        this.selectedProfissionais[key] &&
        !opts.find((o) => o.value === this.selectedProfissionais[key])
      ) {
        this.$delete(this.selectedProfissionais, key)
      }

      return opts
    },

    normalizeOptions(profs) {
      if (!profs) return []
      let arr = []
      if (Array.isArray(profs)) {
        arr = profs
      } else if (typeof profs === 'string') {
        try {
          arr = JSON.parse(profs)
        } catch (e) {
          arr = []
        }
      }
      return arr.map((n) => ({ label: n, value: n }))
    },

    onSelectProfissional(item, value) {
      const key = this.rowKey(item)
      this.$set(this.selectedProfissionais, key, value)
      this.$set(item, 'profissionalSelected', value)
      this.$emit('profissional-selecionado', {
        nu_ine: item.nu_ine,
        nu_micro_area: item.nu_micro_area,
        profissional: value,
      })
    },

    async modalCadastrosValidos(item) {
      try {
        this.modal.loading = true
        this.modal.show = true

        this.modal.filter.greens = false
        this.modal.filter.reds = false
        this.modal.filter.oranges = false

        this.modal.table.itemsOriginais = []
        this.modal.table.items = []

        const inicio = this.dataInicial.replaceAll('-', '')
        const fim = this.dataFinal.replaceAll('-', '')

        const response = await this.$api.get(
          `/app/desempenho-por-acs/${this.$store.state.cod_ibge}/${inicio}/${fim}/cadastros-validos/equipe/${item.co_equipe}/microarea/${item.nu_micro_area}`
        )
        if (response) {
          this.modal.table.itemsOriginais = response.data
          this.modal.table.items = response.data
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.modal.loading = false
      }
    },

    onChangeReds(event) {
      this.modal.filter.oranges = false
      this.modal.filter.greens = false
    },

    onChangeGreens(event) {
      this.modal.filter.oranges = false
      this.modal.filter.reds = false
    },

    onChangeOranges(event) {
      this.modal.filter.reds = false
      this.modal.filter.greens = false
    },

    getRowColorModal(item) {
      if (item.st_cad_valido == 1) {
        return 'table-row-color-green'
      }
      if (item.st_cad_valido == 2) {
        return 'table-row-color-red'
      }
      if (item.st_cad_valido == 0) {
        return 'table-row-color-orange'
      }
    },
  },
}
</script>

<style lang="scss" scoped>
#desempenho-por-acs .cpf-cns {
  margin-bottom: 0px;
}
#desempenho-por-acs .td-interna {
  border-bottom: unset;
  padding: 0 16px;
  gap: 5px;
  margin: 10px 0px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 0px;
  gap: 20px;
  span {
    width: 195px;
    display: flex;
  }
  .div-td-interna {
    display: flex;
    /*   min-width: 67px; */
    gap: 5px;
  }

  @media screen and (max-width: 600px) {
    display: flex;
    align-items: center;
  }
  span {
    font-weight: bold;
    color: #00000099;
    font-size: 16px;
  }
}

#modal-desempenho-microarea {
  .subtitle {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    .subtitle-item {
      font-size: 16px;
      span {
        width: 15px;
        height: 15px;
        display: inline-block;
        vertical-align: middle;
        &.green {
          background: green;
        }
        &.red {
          background: red;
        }
        &.orange {
          background: orange;
        }
      }
    }
  }
}
</style>

<style>
#desempenho-por-acs .v-data-table,
#desempenho-por-acs .v-data-table__wrapper,
#desempenho-por-acs .v-card.tabela {
  overflow: visible !important;
}

/* aumenta a prioridade do menu do vue-select */
#desempenho-por-acs .vs__dropdown-menu {
  z-index: 99999 !important;
}

#desempenho-por-acs .select-profissional {
  position: relative;
  z-index: auto;
}

#desempenho-por-acs .select-profissional .v-select {
  min-width: 180px;
  z-index: auto;
}
</style>
